import React, { Component } from "react";
import { Grid } from "semantic-ui-react";

class AttachmentItem extends Component {
  render() {
    return (
      <Grid.Column width={8}>
        <div className="attachment-item">
          {this.props.img && <img src={this.props.img} alt={this.props.title} />}
          <div className="attachment-item-text">
            <span>{this.props.part}</span>
            <h3>{this.props.title}</h3>
            {/* <p>{this.props.desc}</p> */}
          </div>
        </div>
      </Grid.Column>
    );
  }
}

export default AttachmentItem;



// WEBPACK FOOTER //
// ./src/components/AttachmentItem/index.js